module.exports = __webpack_public_path__ + "assets/icons/ic_ccon_filled_24px.svg";